import { useTranslations } from "contexts/LocalizationContext";

import { RowStyles } from "components/Row";
import { Box, Flex, Text, Heading } from "@chakra-ui/react";
import SearchBar from "./SearchBar";

const Header = () => {
  const translations = useTranslations();

  return (
    <Box pt={{ base: 24, lg: 40 }}>
      <Flex direction="column" pt={28} pb={24} bg="black" alignItems="center" sx={RowStyles["colored-hills"]}>
        <Text textTransform="uppercase" color="primary.500" fontWeight="bold" fontSize="sm" mb={2}>
          {translations("help_center")}
        </Text>
        <Heading color="white" variant="h1" as="h1" textAlign="center">
          {translations("how_can_we_help")}
        </Heading>
        <SearchBar />
      </Flex>
    </Box>
  );
};

export default Header;
